import React, {FC, useState} from "react";
import {Employee} from "../../../lib/src/api/dto/Employee"
import {ModalFooter} from "@traas/lib/src/components/layout/ModalProvider";
import {faExclamationCircle, faFileExport, faRefresh} from "@fortawesome/free-solid-svg-icons";
import {Input} from "@traas/lib/src/components/form/Input";
import {Button} from "@traas/lib/src/components/form/Button";
import moment from "moment";
import {ValidationError} from "../api/api";
import { Callout } from "@traas/lib/src/components/content/Callout";
import {TimeRegistration} from "../../../lib/src/api/dto/TimeRegistration";
import {useApiService} from "../../../lib/src/api/hooks/useApiService";
import {getToken} from "@ventumsoftware/react-toolkit";
import config from "../config";
import {useNavigate} from "react-router";

export const BulkHoursOverview: FC<{ hours: TimeRegistration[], employees: Employee[] }> = (props) => {
  const [from, setFrom] = useState<Date>(moment().startOf("month").startOf('day').toDate())
  const [to, setTo] = useState<Date>(moment().endOf("month").endOf('day').toDate())
  const {timeRegistrationService} = useApiService(config, getToken, useNavigate())
  const [errors, setErrors] = React.useState<string[]>([])
  const [bulkHours, setBulkHours] = useState<{[employeeId: string]: number}>({})
  const fetchBulkHours = async (from: Date, to: Date) => {
    setErrors([])
    try {
      const result = await timeRegistrationService.browseByWindow(from, to)
      setBulkHours(result)
    } catch (e) {
      if (e instanceof ValidationError) {
        setErrors(Object.values(e.errors).flat())
      } else {
        console.error("Unexpected error:", e)
      }
    }
  }

  const getEmployeeName = (employeeId: string) => {
    const employee = props.employees.find((e) => e.id === employeeId)
    return employee ? `${employee.firstName} ${employee.lastName}` : "Onbekend"
  }

  return <>
    <div className={'flex flex-row space-x-3'}>
      <div className={''}>
        <Input type={'date'} label={'Van'} value={from} onChange={(d) => setFrom(d)}/>
      </div>
      <div className={''}>
        <Input type={'date'} label={'Tot'} value={to} onChange={(d) => setTo(d)}/>
      </div>
      <div className={'col-span-3 flex items-end'}>
        <Button type={'primary'} size={'md'} text={'Ophalen'} icon={faRefresh} disabled={!to || !from} onClick={() => {
          fetchBulkHours(from!, to!)
        }} />
      </div>
    </div>

      {errors.length > 0 && (
        <div className="mt-4 text-red-500 space-y-1">
          {errors.map((err, idx) => (
            <div key={idx}>{err}</div>
          ))}
        </div>
      )}

    <div className="mt-6">
      {bulkHours.length === 0 ? (
        <p className="text-slate-700">
          Geen gegevens gevonden voor de geselecteerde periode.
        </p>
      ) : <>
        <div className={'border border-slate-200 rounded-sm overflow-hidden'}>
          <table className="w-full text-sm">
            <thead className="bg-gray-100 text-left">
            <tr>
              <th className="p-2 border-r border-slate-200">Naam</th>
              <th className="p-2">Uren</th>
            </tr>
            </thead>
            <tbody>
            {Object.entries(bulkHours).map(([employeeId, hours]) => {
              const employeeName = getEmployeeName(employeeId)
              return (
                <tr key={employeeId} className="border-t border-slate-200">
                  <td className="p-2 border-r border-slate-200">{employeeName}</td>
                  <td className="p-2">{hours.toString()}</td>
                </tr>
              )
            })}
            </tbody>
          </table>
        </div>
        <Callout color={'danger'} icon={faExclamationCircle}>
          <h2 className={'font-bold'}>Let op!</h2>
          <div className={'text-sm'}>
            Bij het exporteren van de uren worden deze uit de administratie opgeschoond. Om dit terug te draaien dient contact met Ventum&nbsp;Software opgenomen te worden.
          </div>
        </Callout>
      </>}
    </div>


    <ModalFooter text="Exporteren" icon={faFileExport} onSubmit={async () => {
      const blob = await timeRegistrationService.exportByWindow(from!, to!);
      const file = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = file
      a.download = `uren-export_${moment().format('DD-MM-YYYY')}.pdf`;
      a.click()
      URL.revokeObjectURL(file)
    }} />
    </>
}